import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';

import * as React from 'react';

type MenuItem = {
  link: string;
  text: string;
};

const MENU_ITEMS: MenuItem[] = [
  {
    link: '/',
    text: 'Home',
  },
  // {
  //   link: '/about',
  //   text: 'About',
  // },
];

const Header = React.memo(() => {
  const router = useRouter();
  const [openMenu, setOpenMenu] = React.useState(false);
  // console.log(`Header openMenu=${openMenu}`);
  return (
    <nav className="w-full">
      <div
        id="progress"
        className="top-0 z-20 h-1"
        style={{
          background: 'linear-gradient(to right, #4dc0b5 var(--scroll), transparent 0)',
        }}
      />

      <div className="flex flex-wrap items-center justify-between w-full py-3 mx-auto mt-0 md:max-w-4xl">
        <div className="pl-4">
          <Link className="text-xl font-extrabold text-gray-900 no-underline hover:no-underline" href="/">
            lifetime trails
          </Link>
        </div>

        <div className="block pr-4 lg:hidden">
          <button
            id="nav-toggle"
            type="button"
            className="flex items-center px-3 py-2 text-gray-500 appearance-none hover:text-gray-900 hover:border-teal-500 focus:outline-none"
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => setOpenMenu(!openMenu)}
            onBlur={() => setOpenMenu(false)}
          >
            <svg className="w-3 h-3 fill-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>

        <div
          id="nav-content"
          className={`bg-gray-100 border-b flex-grow lg:border-none lg:flex lg:items-center lg:mt-0 lg:shadow-none lg:w-auto md:bg-transparent mt-2 shadow w-full z-20 ${
            openMenu ? 'block' : 'hidden'
          }`}
        >
          <ul className="items-center justify-end flex-1 list-reset lg:flex">
            {MENU_ITEMS.map(({ link, text }) => (
              <li key={link} className="mr-3">
                <Link
                  className={
                    router.pathname === link
                      ? 'inline-block py-2 px-4 text-gray-900 font-bold no-underline'
                      : 'inline-block text-gray-600 no-underline hover:text-gray-900 hover:text-underline py-2 px-4'
                  }
                  href={link}
                >
                  {text}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
});

export default Header;
